import { NodeContext, NodeContextItem } from "src/types/node-context.types";

export class NodeContextImpl implements NodeContext {
  private items: NodeContextItem[] = [];

  getLatest(
    match: (entry: NodeContextItem) => boolean
  ): NodeContextItem | undefined {
    return this.items
      .slice()
      .reverse()
      .find((item) => match(item));
  }

  getAll(): NodeContextItem[] {
    return this.items;
  }

  setAll(items: NodeContextItem[]): NodeContextImpl {
    this.items = items;
    return this;
  }

  append(item: NodeContextItem): NodeContextImpl {
    this.items.push(item);
    return this;
  }

  copy(): NodeContextImpl {
    const copy = new NodeContextImpl();
    copy.setAll(this.items.slice());
    return copy;
  }
}
